var map = {
	"./Birthday(1).jpg": 6577,
	"./Birthday(13).jpg": 6478,
	"./Birthday(14).jpg": 3175,
	"./Birthday(15).jpg": 9588,
	"./Birthday(17).jpg": 3890,
	"./Birthday(19).jpg": 7304,
	"./Birthday(2).jpg": 9960,
	"./Birthday(3).jpg": 6619,
	"./Birthday(5).jpg": 981,
	"./Birthday(6).jpg": 6348,
	"./Birthday(9).jpg": 2809,
	"./New folder/Birthday(10).jpg": 7776,
	"./New folder/Birthday(11).jpg": 339,
	"./New folder/Birthday(12).jpg": 2750,
	"./New folder/Birthday(16).jpg": 162,
	"./New folder/Birthday(18).jpg": 3576,
	"./New folder/Birthday(4).jpg": 6515,
	"./New folder/Birthday(7).jpg": 1454,
	"./New folder/Birthday(8).jpg": 9487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 202;